<template>
  <transition :name="slideDirection" :duration="{ enter: 400, leave: 400 }">
    <section class="pane-section" :class="classObject" v-show="isActive">
      <div class="pane-section-container">
        <slot></slot>
        <slot name="help"></slot>
      </div>
    </section>
  </transition>
</template>

<script>
export default {
  computed: {
    classObject() {
      return {
        "pane-left": this.alignment === "left",
        "pane-right": this.alignment === "right",
      };
    },

    isActive() {
      return this.activePane === this.paneId;
    },

    slideDirection() {
      return "pane-slide-" + this.alignment;
    },
  },

  props: {
    activePane: {
      type: String,
    },

    alignment: {
      type: String,
    },

    paneId: {
      type: String,
    },
  },
};
</script>
